module.exports = __webpack_public_path__ + "img/nk_company.cbe3e5a1.png";